export const AREA_DASHBOARD_WIDGET_NAMESPACE = 'widget.area-dashboard'
